module.exports = __webpack_public_path__ + "img/games-9.71db0343.webp";